import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import PolozkaCiselnik from '../model/ciselniky/PolozkaCiselnik';
import { ClientStatus } from '../model/ClientStatus';
import { useClientFetch } from '../context/ClientStatusContext';
import { fetchCiselnikPolozky } from '../client/external/ciselniky/ciselnikPolozkaClient';

interface ReturnType {
  polozkyCiselnik: PolozkaCiselnik[];
  polozkyCiselnikStatus: ClientStatus;
}

export default (
  ids: string[],
  typy: TypCiselnikaEnum[],
  platny: boolean,
  kody: string[],
  execute = true,
): ReturnType => {
  const {
    data: polozkyCiselnik,
    status: polozkyCiselnikStatus,
  } = useClientFetch(
    fetchCiselnikPolozky,
    [ids, typy, platny, '', kody, undefined, execute],
    [],
  );

  return {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  };
};
